// Transfer Mutations

export const updateTransferList = (state, payload) => {
  state.transferList = payload
}

export const fetchTransferProductsList = (state, payload) => {
  state.transferProductsList = payload
}

export const fetchTransferInfo = (state, payload) => {
  state.transferInfo = payload
}

export const fetchPendingTransferCount = (state, payload) => {
  state.pendingTransferCount = payload
}

export const setTransferOutletsList = (state, payload) => {
  state.transferOutletsList = payload
}
